import MomentUtils from '@date-io/moment';
import { Button, TextField } from "@material-ui/core";
import { WithStyles, createStyles, withStyles } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import _ from 'lodash';
import moment from 'moment';
import * as React from "react";
import { ConnectedProps, connect } from 'react-redux';
import Select from 'react-select';
import { CustomerPlantManagementOptions, CustomerPlantModalityOptions, CustomerPlantPlatformOptions, CustomerPlantSolutionOptions, CustomerPlantTypeOptions } from '../../codec/customerDomainDecoder';
import { IState } from '../../redux/store';
import { ICustomerDomainFormDTO } from '../../repository/jago/model/input/IDomainInDTO';
import { ISegmentTypeEnum } from '../../repository/jago/model/output/ISegmentTypeEnum';
import AbilityProvider from '../../services/PermissionService/AbilityProvider';
import { PERMISSIONS } from '../../services/PermissionService/PermissionConstants';
import { BLUE } from '../../style/StyleConsts';
import translations from '../../translations/i18next';
import Utils, { isSegmentTypeDeprecated } from '../../utils/Utils';
import ReduxLanguage from "../ReduxLanguage";

const styles = createStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'white',
    padding: 20,
    height: '100%',
    flex: 1,
  },
  formTitle: {
    fontWeight: 'bold',
    marginBottom: 20,
  },
  errorText: {
    color: 'red'
  },
  inputTitle: {
    marginTop: 20,
    marginBottom: 8,
    fontSize: 18,
    fontWeight: 'bold',
  },
  disabledButton: {
    backgroundColor: 'red'
  },
  inputTitleContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  italicText: {
    fontStyle: 'italic',
  },
  customerDataColumn: {
    flex: 1,
  },
  actionButton: {
    width: 'fit-content',
    color: 'white',
    marginLeft: 20,
    padding: 4,
    paddingLeft: 10,
    paddingRight: 10,
    fontWeight: 'bold'
  },
  actionButtonText: {
    margin: 0,
    fontWeight: 'bold',
  },
  icon: {
    fontSize: 15,
    marginRight: 5,
  },
  iconCustomer: {
    marginRight: 5,
    fontSize: 25,
  },
  dateInput: {
    height: 33
  }
});

export interface ICustomerPlantFormState {
  customerPlant: ICustomerDomainFormDTO;
  errors: Record<keyof ICustomerDomainFormDTO, boolean>;
  initialSegmentType?: string;
};

export interface ICustomerPlantFormProps extends WithStyles<typeof styles>{
  onCreateEditCustomerPlant: (customerPlant: ICustomerDomainFormDTO) => void;
  customerPlant?: ICustomerDomainFormDTO;
  customerId: number;
}

type IReduxProps = ConnectedProps<typeof connector>;

export type ComponentProps = ICustomerPlantFormProps & IReduxProps;
class CustomerPlantForm extends React.Component<ComponentProps, ICustomerPlantFormState> {

  constructor(props: ComponentProps) {
    super(props);
    this.state = {
      initialSegmentType: props.customerPlant ? props.customerPlant.subSegment : undefined,
      customerPlant: props.customerPlant ? props.customerPlant : {
        id: null,
        customerId: props.customerId,
        name: '',
        hostname: '',
        lockbaseId: '',
        type: '',
        solution: '',
        platform: '',
        management: '',
        modality: 'PERIODIC',
        subSegment: '',
        zenDeskId: '',
        loginData: '',
        license1ris: '',
      },
      errors: {
        id: null,
        customerId: null,
        name: null,
        hostname: null,
        lockbaseId: null,
        type: null,
        solution: null,
        platform: null,
        management: null,
        modality: null,
        subSegment: null,
        zenDeskId: null,
        loginData: null,
        license1ris: null,
      },
    };
  }

  // Helper function to get translated label for solution options
  getSolutionOptionLabel = (option: { value: string, label: string }) => {
    return option.label;
  }

  // Helper function to get translated label for management options  
  getManagementOptionLabel = (option: { value: string, label: string }) => {
    return option.label;
  }

  // Helper function to get translated label for modality options
  getModalityOptionLabel = (option: { value: string, label: string }) => {
    return option.label;
  }

  // Helper function to get translated label for type options
  getTypeOptionLabel = (option: { value: string, label: string }) => {
    return option.label;
  }

  onChangeValue(field: keyof ICustomerDomainFormDTO, mandatory: boolean, value?: any) {
    const { customerPlant, errors } = this.state;
    this.setState({
      errors: { ...errors, [field]: !value && mandatory ? true : false }
    });
    (customerPlant as any)[field] = value;
    this.setState({ customerPlant });
  }

  onSubmitForm() {
    const { customerPlant } = this.state;
    if (!this.canSubmitForm()) {
      return;
    }
    const { onCreateEditCustomerPlant } = this.props;
    onCreateEditCustomerPlant(customerPlant);
  }

  canSubmitForm() {
    const { customerPlant } = this.state;
    return customerPlant.name && customerPlant.type && customerPlant.solution && customerPlant.management;
  }

  public render() {
    const { classes} = this.props;
    const { customerPlant, errors, initialSegmentType } = this.state;
    
    const isEdit = Boolean(this.props.customerPlant)
    const canEdit = (isEdit && AbilityProvider.getAbilityHelper().hasPermission(PERMISSIONS.CUSTOMER_PLANTS_UPDATE)) || 
      (!isEdit && AbilityProvider.getAbilityHelper().hasPermission(PERMISSIONS.CUSTOMER_PLANTS_CREATE))

    const segmentTypeOptions = _.map(ISegmentTypeEnum, (v) => ({ value: v }))

    return (
      <MuiPickersUtilsProvider utils={MomentUtils} locale={moment.locale()}>
        <div className={classes.container}>
          <div style={{ flex: 0, marginRight: 10 }}>
          <TextField
              autoComplete='off'
              id="outlined-basic"
              label={<ReduxLanguage languageKey={'credits.customerPlantName'} />}
              variant="outlined"
              fullWidth
              required
              disabled={!canEdit}
              error={errors.name}
              value={customerPlant.name}
              style={{ marginTop: 20 }}
              onChange={e => this.onChangeValue('name', true, e.target.value)}
            />
            <h4 style={{ marginTop: 34, marginLeft: 0, marginBottom: 3, fontWeight: 'bold' }}>{<ReduxLanguage languageKey={'credits.customerPlantType'} />}<span style={{ color: 'red' }}>*</span></h4>
            <Select
              options={_.map(_.keys(CustomerPlantTypeOptions), (v) => ({ 
                value: v, 
                label: Utils.getTranslatedTypeLabel(v) 
              }))}
              isDisabled={!canEdit}
              isClearable
              placeholder={<ReduxLanguage languageKey={'credits.customerPlantType'} />}
              getOptionLabel={this.getTypeOptionLabel}
              value={customerPlant.type ? { 
                value: customerPlant.type, 
                label: Utils.getTranslatedTypeLabel(customerPlant.type) 
              } : null}
              onChange={(e) => this.onChangeValue('type', true, e ? e.value : null)}
              styles={{
                menu: (styles) => Object.assign(styles, { zIndex: 1000 }),
                control: (styles) => ({ ...styles, minHeight: 55, marginTop: 10, marginBottom: 10 }),
              }} 
            />
            <TextField
              autoComplete='off'
              id="outlined-basic"
              label={<ReduxLanguage languageKey={'credits.customerPlantHostname'} />}
              variant="outlined"
              fullWidth
              disabled={!canEdit}
              error={errors.hostname}
              value={customerPlant.hostname}
              style={{ marginTop: 20 }}
              onChange={e => this.onChangeValue('hostname', true, e.target.value)}
            />
            <TextField
              autoComplete='off'
              id="outlined-basic"
              label={<ReduxLanguage languageKey={'credits.customerPlantLockbaseId'} />}
              variant="outlined"
              fullWidth
              disabled={!canEdit}
              error={errors.lockbaseId}
              value={customerPlant.lockbaseId}
              style={{ marginTop: 25 }}
              onChange={e => this.onChangeValue('lockbaseId', true, e.target.value)}
            />
            <h4 style={{ marginTop: 34, marginLeft: 0, marginBottom: 3, fontWeight: 'bold' }}>{<ReduxLanguage languageKey={'credits.customerPlantSolution'} />}<span style={{ color: 'red' }}>*</span></h4>
            <Select
              options={_.map(CustomerPlantSolutionOptions, (v) => ({ 
                value: v, 
                label: Utils.getTranslatedSolutionLabel(v) 
              }))}
              isDisabled={isEdit || !canEdit}
              isClearable
              placeholder={<ReduxLanguage languageKey={'credits.customerPlantSolution'} />}
              getOptionLabel={this.getSolutionOptionLabel}
              value={customerPlant.solution ? { 
                value: customerPlant.solution, 
                label: Utils.getTranslatedSolutionLabel(customerPlant.solution) 
              } : null}
              onChange={(e) => this.onChangeValue('solution', true, e ? e.value : null)}
              styles={{
                menu: (styles) => Object.assign(styles, { zIndex: 1000 }),
                control: (styles) => ({ ...styles, minHeight: 55, marginTop: 10, marginBottom: 10 }),
              }} 
            />
            <h4 style={{ marginTop: 34, marginLeft: 0, marginBottom: 3, fontWeight: 'bold' }}>{<ReduxLanguage languageKey={'credits.customerPlantPlatform'} />}</h4>
            <Select
              options={_.map(_.keys(CustomerPlantPlatformOptions), (v) => ({ 
                value: v, 
                label: Utils.getTranslatedPlatformLabel(v) 
              }))}
              isDisabled={isEdit || !canEdit}
              isClearable
              placeholder={<ReduxLanguage languageKey={'credits.customerPlantPlatform'} />}
              getOptionLabel={this.getSolutionOptionLabel}
              value={customerPlant.platform ? { 
                value: customerPlant.platform, 
                label: Utils.getTranslatedPlatformLabel(customerPlant.platform) 
              } : null}
              onChange={(e) => this.onChangeValue('platform', true, e ? e.value : null)}
              styles={{
                menu: (styles) => Object.assign(styles, { zIndex: 1000 }),
                control: (styles) => ({ ...styles, minHeight: 55, marginTop: 10, marginBottom: 10 }),
              }} 
            />

            <h4 style={{ marginTop: 34, marginLeft: 0, marginBottom: 3, fontWeight: 'bold' }}>{<ReduxLanguage languageKey={'credits.customerPlantManagement'} />}<span style={{ color: 'red' }}>*</span></h4>
            <Select
              options={_.map(CustomerPlantManagementOptions, (v) => ({ 
                value: v, 
                label: Utils.getTranslatedManagementLabel(v) 
              }))}
              isDisabled={isEdit || !canEdit}
              isClearable
              placeholder={<ReduxLanguage languageKey={'credits.customerPlantManagement'} />}
              getOptionLabel={this.getManagementOptionLabel}
              value={customerPlant.management ? { 
                value: customerPlant.management, 
                label: Utils.getTranslatedManagementLabel(customerPlant.management) 
              } : null}
              onChange={(e) => this.onChangeValue('management', false, e ? e.value : null)}
              styles={{
                menu: (styles) => Object.assign(styles, { zIndex: 1000 }),
                control: (styles) => ({ ...styles, minHeight: 55, marginTop: 10, marginBottom: 10 }),
              }} 
            />
            {/* <h4 style={{ marginTop: 34, marginLeft: 0, marginBottom: 3, fontWeight: 'bold' }}>{<ReduxLanguage languageKey={'credits.customerPlantModality'} />}</h4>
            <Select
              options={_.map(CustomerPlantModalityOptions, (v) => ({ 
                value: v, 
                label: Utils.getTranslatedModalityLabel(v) 
              }))}
              isClearable
              placeholder={<ReduxLanguage languageKey={'credits.customerPlantModality'} />}
              getOptionLabel={this.getModalityOptionLabel}
              isDisabled={true}
              value={customerPlant.modality ? { 
                value: customerPlant.modality, 
                label: Utils.getTranslatedModalityLabel(customerPlant.modality) 
              } : null}
              onChange={(e) => this.onChangeValue('modality', false, e ? e.value : null)}
              styles={{
                menu: (styles) => Object.assign(styles, { zIndex: 1000 }),
                control: (styles) => ({ ...styles, minHeight: 55, marginTop: 10, marginBottom: 10 }),
              }} 
            /> */}
            <h4 style={{ marginTop: 34, marginLeft: 0, marginBottom: 3, fontWeight: 'bold' }}>{<ReduxLanguage languageKey={'credits.customerPlantSubSegment'} />}</h4>
            <Select
              value={segmentTypeOptions.filter(e=>e.value===customerPlant.subSegment).length?segmentTypeOptions.filter(e=>e.value===customerPlant.subSegment)[0]:null}
              options={segmentTypeOptions}
              isClearable
              required
              placeholder={<ReduxLanguage languageKey={'forms.selectSegmentType'} />}
              onChange={(e) => this.onChangeValue('subSegment', false, e ? e.value : null)}
              formatOptionLabel={(v) => v.value ? (
                isSegmentTypeDeprecated(v.value) ? (
                  <>
                    <b style={{ color: '#999' }}>{`${translations.t('segmentTypes.'+v.value+"_name")}`}</b> 
                    <span style={{ color: '#999' }}>{translations.t('segmentTypes.'+v.value+"_description")!==('segmentTypes.'+v.value+"_description") ? ` [${translations.t('segmentTypes.'+v.value+"_description")}]` : ""}</span>
                    <span style={{ color: '#999', fontStyle: 'italic', marginLeft: 2 }}>({translations.t('segmentTypes.deprecated')})</span>
                  </>
                ) : (
                  <>
                    <span style={{ }}>{translations.t('segmentTypes.'+v.value+"_name")}</span>
                  </>
                )
              ):""}
              isOptionDisabled={(option) => isSegmentTypeDeprecated(option.value) && option.value !== initialSegmentType}
              styles={{
                menu: (styles) => Object.assign(styles, { zIndex: 1000 }),
                control: (styles) => ({ ...styles, minHeight: 55 }),
                option: (styles, { isDisabled }) => ({
                  ...styles,
                  color: isDisabled ? '#999' : styles.color,
                  backgroundColor: isDisabled ? '#f5f5f5' : styles.backgroundColor,
                  cursor: isDisabled ? 'not-allowed' : styles.cursor,
                }),
              }}
            />
            <div style={{ display: 'flex', alignItems: 'flex-end', gap: 10 }}>
              <TextField
                autoComplete='off'
                id="outlined-basic"
                label={<ReduxLanguage languageKey={'credits.customerPlantZendesk'} />}
                variant="outlined"
                fullWidth
                disabled={!canEdit}
                error={errors.zenDeskId}
                value={customerPlant.zenDeskId}
                style={{ marginTop: 20 }}
                onChange={e => this.onChangeValue('zenDeskId', false, e.target.value)}
              />
              <Button
                variant="contained"
                style={{ 
                  minWidth: 120,
                  height: 56,
                  backgroundColor: BLUE,
                  color: 'white',
                  fontWeight: 'bold',
                  opacity: customerPlant.zenDeskId ? 1 : 0,
                  pointerEvents: customerPlant.zenDeskId ? 'auto' : 'none'
                }}
                onClick={() => {
                  if (customerPlant.zenDeskId) {
                    window.open(`https://zendesk.com/customer/${customerPlant.zenDeskId}`, '_blank');
                  }
                }}
              >
                <ReduxLanguage languageKey="credits.openZendesk" />
              </Button>
            </div>
            <TextField
              autoComplete='off'
              id="outlined-basic"
              label={<ReduxLanguage languageKey={'credits.customerPlantLoginData'} />}
              variant="outlined"
              fullWidth
              disabled={!canEdit}
              error={errors.loginData}
              value={customerPlant.loginData}
              style={{ marginTop: 20 }}
              onChange={e => this.onChangeValue('loginData', false, e.target.value)}
            />
            <TextField
              autoComplete='off'
              id="outlined-basic"
              label={<ReduxLanguage languageKey={'credits.customerPlantLicense1ris'} />}
              variant="outlined"
              fullWidth
              disabled={!canEdit}
              error={errors.license1ris}
              value={customerPlant.license1ris}
              style={{ marginTop: 20 }}
              onChange={e => this.onChangeValue('license1ris', false, e.target.value)}
            />
          </div>
          <div style={{ flex: 1, marginRight: 10 }}>
          </div>
          {canEdit && (
            <div style={{position:'sticky',bottom:'0',paddingTop:'20px',backgroundColor:'white',marginLeft:'-20px',marginRight:'-20px',zIndex:1}}>
              <Button
                variant="contained"
                disabled={!this.canSubmitForm()}
                style={{ width: '100%', opacity: this.canSubmitForm() ? 1 : 0.5, backgroundColor: '#5AC0B1', color: 'white', borderRadius: 0, height: 45, fontWeight: 'bold'  }}
                onClick={() => this.onSubmitForm()}
              >
                <ReduxLanguage languageKey="forms.save" />
              </Button>
            </div>
          )}
        </div>
      </MuiPickersUtilsProvider>
    );
  }
}

function mapStateToProps(state: IState) {
  return {
    
  };
}

const connector = connect(mapStateToProps);

export default connector(withStyles(styles)(CustomerPlantForm));